<template>
  <div>
    <div class="d-flex link" @click="() => this.showTermsModal = this.showTermsModal !== true">
      {{ iconText }}
      <div :class="iconClass">&nbsp</div>
    </div>
    <TermsModal :showTermsModal="showTermsModal" />
  </div>
</template>

<script>

import TermsModal from "./TermsModal";

export default {
  components: {
    TermsModal
  },
  props: ['iconClass', 'iconText'],
  data() {
    return {
      showTermsModal: false
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../../../styles/spinner';
@import '~styles/app.scss';
@import '../assets/styles/payment';

</style>



// WEBPACK FOOTER //
// src/components/payment/ui/RegisterCardButton.vue